import riFetcher from './ri';

export default {
    RI: riFetcher,
};
